export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/compare.worker.2e075e5e.worker.js");
}
